module.exports = __webpack_public_path__ + "img/cns_email_ios18.3aaf16e8.png";